import { useGetBuyData } from "api/trading/useGetBuyData";
import { TradableSecurity as TradableSecurityInterface } from "api/trading/useGetTradebleSecurities";
import { useTradablePortfolioSelect } from "components/TradingModals/useTradablePortfolioSelect";

export const useFilterSecuritiesByPortfolioCurrency = (
  allSecurities: TradableSecurityInterface[]
): [TradableSecurityInterface[], string?] => {
  const { portfolioId } = useTradablePortfolioSelect();
  const { data, loading } = useGetBuyData(portfolioId.toString());
  if (loading) return [allSecurities];
  const portfolioCurrency = data?.currency;
  if (!portfolioCurrency) {
    console.error("Unable to determine currency to filter portfolios.");
    return [allSecurities];
  }
  const filteredSecurities: TradableSecurityInterface[] = [];

  allSecurities.forEach((security) => {
    const { currency: securityCurrency } = security;
    if (securityCurrency?.securityCode === portfolioCurrency) {
      if (!securityCurrency?.securityCode) {
        console.error(`Missing currency for security. Canceling filtering.`);
        return allSecurities;
      }
      filteredSecurities.push(security);
    }
  });

  return [filteredSecurities, portfolioCurrency];
};
